import React, {useMemo, useState} from "react";
import TableComponent from "../../common/components/TableComponent";
import {ThumbnailImg} from "../category/advertisersComponent";
import {getSignedURL} from "../../managers/awsService";
import DeleteDialogComponent from "../deleteDialog";
import EditDialogComponent from "../editDialog";
import {
    AddNewButton,
    ComponentHeader,
    MainContainer,
    SearchBox,
    SearchContainer,
    SearchIcon,
    SearchInput
} from "./styles";
import moment from "moment";

export default function ProductListComponent(props) {
    const {refreshList, state} = props
    const [searchText, setSearchText] = useState('')

    const filteredList = useMemo(() => searchText && state.itemsList ?
        state.itemsList.filter(data => data.name?.toLowerCase().includes(searchText))
        : state.itemsList || [], [state.itemsList, searchText])

    return (
        <MainContainer>
            <ComponentHeader>
                <SearchContainer>
                    Items
                    <SearchBox>
                        <SearchInput placeholder="Search" onChange={e => setSearchText(e.target.value)}/>
                        <SearchIcon src="/images/search-icon.svg"/>
                    </SearchBox>
                </SearchContainer>

                <AddNewButton onClick={props.onAddNewProductClicked}>
                    + Add New Item
                </AddNewButton>
            </ComponentHeader>
            <TableComponent.Table cellpadding="0" cellspacing="0">
                <TableComponent.TableHead>
                    <TableComponent.HeadColumn>Thumbnail</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Name</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Category</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Weight</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn>Modified On</TableComponent.HeadColumn>
                    <TableComponent.HeadColumn/>
                    <TableComponent.HeadColumn/>
                </TableComponent.TableHead>
                <TableComponent.TableBody>
                    {filteredList?.map((item) => (
                        <TableComponent.BodyRow key={item._id}>
                            <TableComponent.BodyColumn>
                                <ThumbnailImg src={getSignedURL(item.media)}/>
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>{item.name}</TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {item.category.name}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {item.weight || "-"}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                {moment(item.modifiedOn).format("DD MMM YYYY, hh:mm A")}
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <EditDialogComponent entityName="item" data={item}
                                                     refreshList={refreshList}/>
                            </TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <DeleteDialogComponent entityName="item" id={item._id}
                                                       refreshList={refreshList}/>
                            </TableComponent.BodyColumn>
                        </TableComponent.BodyRow>
                    ))}
                </TableComponent.TableBody>
            </TableComponent.Table>
        </MainContainer>
    );
}
